<template>
  <h1 class="text-lg font-semibold">
    <slot />
  </h1>
</template>
